import {ProfileStatus} from "@/dto/common/ProfileStatus";

export default class RCCRCreateCompanyPayloadDTO {
    companyName = "";
    dba = "";
    companyEin = "";
    businessEntityType: string | null = null;
    companyStatus: ProfileStatus | null = null;
    officerSsn = "";
    officerFirstName = "";
    officerLastName = "";
}